import RefreshIcon from "@mui/icons-material/Refresh";
import { Avatar, Box, Link, Tooltip } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import CustomStyleStatus from "../../components/statusStyleFormat/statusStyleFormat";
import { getAllVisitors } from "../../slices/Approvals/selfRegistarationApprovalSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import BlockVisitorForm from "../BlacklistVisitors/BlockVisitorForm";
import ApproveIcon from "./ApproveIcon";
import SimpleDialogDemo from "./ImageDailogBox";
import RejectIcon from "./RejectIcon";
import RejectRegistartionInvitationDialog from "./RejectRegistartionInvitationDialog";
import SelfRegistrationFilter from "./SelfRegistrationFilter";

function BlockRequestsApprovals() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalPages, setTotalPages] = useState(0);
  const [rows, setRows] = useState([]);
  const [clear, setClear] = useState(false);
  const [totalRecords, setTotalRecords] = useState(1);
  const [openBlacklistVisitor, setOpenBlacklistVisitor] = useState(false);
  const [blacklistId, setBlacklistId] = useState();
  const [restrictReasonType, setRestrictReasonType] = useState();
  const [restrictReason, setRestrictReason] = useState();
  const [removeAccess, setRemoveAccess] = useState();
  const [rejectVisitId, setRejectVisitId] = useState();
  const [rejectVisit, setRejectedVisit] = useState([]);
  const [visitorFirstName, setVisitorFirstName] = useState();
  const [visitorLastName, setVisitorLastName] = useState();
  const [openRejectInvitation, setOpenRejectInvitation] = useState(false);
  const [del, setDel] = useState(false);
  const [pageSize, setPageSize] = useState(0);
  const { setDiaLogBoxBlur } = useContext(ThemeContext);
  const status = ["INITIATED_FOR_BLOCKED"];
  const [filter, setFilter] = React.useState({
    isRestricted: "true",
    visitorTypeId: "",
    purposeTypeId: "",
    status: "INITIATED_FOR_BLOCKED",
    visitMode: [
      "INVITATION",
      "WALKIN_REGISTARTION",
      "WALKIN_REGISTARTION_KIOSK",
      "SELF_REGISTARTION",
      "PRE_REGISTRATION",
    ],
  });

  const defaultFilter = {
    isRestricted: "true",
    visitorTypeId: "",
    purposeTypeId: "",
    status: "INITIATED_FOR_BLOCKED",
    visitMode: [
      "INVITATION",
      "WALKIN_REGISTARTION",
      "WALKIN_REGISTARTION_KIOSK",
      "SELF_REGISTARTION",
      "PRE_REGISTRATION",
    ],
  };

  const applyFilter = (filterData) => {
    setClear(true);
    const query = {
      visitorTypeId: filterData.visitorTypeId,
      purposeTypeId: filterData.purposeTypeId,
      status: filterData.status,
      visitMode: filterData.visitMode,
      isRestricted: filterData.isRestricted,
    };

    setFilter({
      ...filter,
      ...query,
    });
  };

  const resetFilter = () => {
    setClear(false);
    setFilter({
      ...defaultFilter,
    });
  };

  const handleChange = (newPage, size) => {
    setPage(newPage);
    loadData(newPage, size);
    setRowsPerPage(size);
  };

  useEffect(() => {
    loadData(1, rowsPerPage);
  }, [filter]);

  const loadData = (page, rowsPerPage) => {
    const payload = {
      filter: filter,
      page: page,
      rowsPerPage: rowsPerPage,
    };
    dispatch(getAllVisitors(payload))
      .unwrap()
      .then((data) => {
        console.info(data);
        if ((data.code = "CVAI0000" && data.data)) {
          setTotalRecords(data.data.totalCount);
          setRows(data.data.visits);
          setPage(data.data.curPage);
          setPageSize(data.data.pageSize);
          setTotalPages(data.data.totalPages);
        } else {
          setRows([]);
        }
      })
      .catch((er) => {});
  };

  const handleRejectVisit = (params) => {
    setOpenRejectInvitation(!openRejectInvitation);
    setRejectVisitId(params.id);
    setRejectedVisit(params.row);
    setDiaLogBoxBlur(true);
  };

  useEffect(() => {
    if (del === true && parseInt(pageSize) !== 1) {
      loadData(page, rowsPerPage);
      setDel(false);
    } else {
      if (del === true) {
        loadData(page - 1, rowsPerPage);
        setDel(false);
      }
    }
  }, [del]);

  const handleBlacklistVisit = (params) => {
    setOpenBlacklistVisitor(!openBlacklistVisitor);
    setBlacklistId(params.row.id);
    setRestrictReasonType(params.row.blackListId.restrictReasonType);
    setRestrictReason(params.row.blackListId.restrictReason);
    setRemoveAccess(params.row.blackListId.removeAccess);
    setVisitorFirstName(params.row.visitor.firstName);
    setVisitorLastName(params.row.visitor.firstName);
    setDiaLogBoxBlur(true);
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 15) {
      return text.substring(0, 17) + "...";
    } else {
      return text;
    }
  };

  const testBackGroundColors = [
    "#C7D4E7",
    "#F8EACD",
    "#DBE1D7",
    "#EBD3E1",
    "#E2DEED",
    "#EBD3D3",
    "#D7EEE8",
    "#D3F5D5",
    "#E5D9C3",
    "#D2C785",
    "#C6E0E3",
    "#E4D8EB",
    "#D0D1DC",
    "#CCE1D8",
    "#CBDAEC",
    "#F6FCE1",
    "#F6FCE1",
    "#DBD0CE",
    "#C3DFCF",
    "#E6D8E5",
    "#C3EBE1",
    "#C0E5F5",
    "#EBE3B1",
    "#F6CFCF",
    "#ECD4E9",
    "#D5F6CF",
    "#DAD9F5",
    "#F2E1CB",
  ];

  const textColors = [
    "#2D4568",
    "#6C5629",
    "#2F4B1C",
    "#491D37",
    "#20163B",
    "#572626",
    "#214C42",
    "#275E2B",
    "#7D6845",
    "#677820",
    "#29666D",
    "#4E2168",
    "#1E203A",
    "#194130",
    "#143F70",
    "#586E0C",
    "#392871",
    "#543935",
    "#395847",
    "#6D3969",
    "#085341",
    "#1E3C4A",
    "#3E380D",
    "#481515",
    "#381434",
    "#163610",
    "#13123E",
    "#30210E",
  ];

  const getAvatarColor = (name) => {
    const colors = [
      "#C7D4E7",
      "#F8EACD",
      "#DBE1D7",
      "#EBD3E1",
      "#E2DEED",
      "#EBD3D3",
      "#D7EEE8",
      "#D3F5D5",
      "#E5D9C3",
      "#D2C785",
      "#C6E0E3",
      "#E4D8EB",
      "#D0D1DC",
      "#CCE1D8",
      "#CBDAEC",
      "#F6FCE1",
      "#F6FCE1",
      "#DBD0CE",
      "#C3DFCF",
      "#E6D8E5",
      "#C3EBE1",
      "#C0E5F5",
      "#EBE3B1",
      "#F6CFCF",
      "#ECD4E9",
      "#D5F6CF",
      "#DAD9F5",
      "#F2E1CB",
    ];
    const index =
      name.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) %
      colors.length;
    return colors[index];
  };

  const ZoomHandaler = (params) => {
    const { firstName, lastName, profilePhotoURL } = params.row.visitor;

    const getColorIndex = (name) => {
      const total = name
        .toUpperCase()
        .split("")
        .reduce((sum, char) => sum + char.charCodeAt(0), 0);
      return total % testBackGroundColors.length;
    };
    // Get initials
    const initials = `${firstName?.charAt(0) || ""}${lastName?.charAt(0) ||
      ""}`;
    const bgColor = !profilePhotoURL ? getAvatarColor(initials) : "transparent";
    const colorIndex = getColorIndex(initials);
    const textColor = profilePhotoURL ? "inherit" : textColors[colorIndex];

    return (
      <SimpleDialogDemo
        button={
          <Avatar
            style={{
              cursor: "pointer",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={firstName}
            src={profilePhotoURL || undefined}
          >
            {!profilePhotoURL && initials.toUpperCase()}
          </Avatar>
        }
        child={
          <Avatar
            style={{
              width: "300px",
              height: "300px",
              border: "1px solid #FFFF",
              fontSize: "100px",
              borderRadius: "50%",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={firstName}
            src={profilePhotoURL || undefined}
          >
            {!profilePhotoURL && initials.toUpperCase()}
          </Avatar>
        }
      />
    );
  };

  const columns = React.useMemo(() => [
    {
      field: "visitor.profile",
      headerName: "",
      sortable: false,
      width: 10,
      renderCell: (params) => {
        return ZoomHandaler(params);
      },
    },
    {
      field: "visitor.firstName",
      headerName: t("COMMON014"),
      flex: 1,
      minWidth: 150,
      valueGetter: (params) =>
        params.row.visitor.lastName !== null
          ? params.row.visitor.firstName + " " + params.row.visitor.lastName
          : params.row.visitor.firstName,
      renderCell: (params) => (
        <Tooltip
          title={` ${
            params.row.visitor.lastName !== null
              ? params.row.visitor.firstName + " " + params.row.visitor.lastName
              : params.row.visitor.firstName
          }`}
          placement="bottom-start"
        >
          <span>
            {handleTextOverflow(
              params.row.visitor.lastName !== null
                ? params.row.visitor.firstName +
                    " " +
                    params.row.visitor.lastName
                : params.row.visitor.firstName,
            )}
          </span>
        </Tooltip>
      ),
    },
    {
      field: "visitor.phone",
      headerName: t("COMMON063"),
      type: "singleSelect",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.row.visitor.phone,
    },
    {
      field: "visitor.email",
      headerName: t("VISUPDATE0001"),
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.row.visitor.email,
      renderCell: (params) => (
        <Tooltip
          title={` ${params.row.visitor.email}`}
          placement="bottom-start"
        >
          <span>{handleTextOverflow(params.row.visitor.email)}</span>
        </Tooltip>
      ),
    },

    {
      field: "status",
      headerName: t("COMMON001"),
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        return <CustomStyleStatus row={params.row.status} icon={false} />;
      },
    },
    {
      field: "Actions",
      headerName: t("ACTION"),
      type: "actions",
      flex: 1,
      minWidth: 190,
      width: 150,
      headerAlign: "center",
      getActions: (params) => [
        <Box onClick={() => handleBlacklistVisit(params)}>
          <ApproveIcon />
        </Box>,
        <Box onClick={() => handleRejectVisit(params)}>
          <RejectIcon />
        </Box>,
      ],
    },
  ]);

  return (
    <>
      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row-reverse"}
        alignItems={"center"}
        gap="3px"
      >
        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "0.8",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {t("CLEARFILTER")}
            </Link>
          )}
        </Box>

        <Tooltip title={t("COMMON002")}>
          <Box item className="refreshIcon">
            <RefreshIcon onClick={() => loadData(page, rowsPerPage)} />
          </Box>
        </Tooltip>

        <Box item>
          <SelfRegistrationFilter
            rowsPerPage={rowsPerPage}
            selectedObject={filter.visitMode}
            status={status}
            applyFilter={(data) => applyFilter(data)}
          />
        </Box>
      </Box>

      <div style={{ height: 300, width: "100%", paddingTop: "20px" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          approvals={true}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          count={totalRecords}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>

      {openRejectInvitation && (
        <RejectRegistartionInvitationDialog
          open={openRejectInvitation}
          handleClose={(data) => {
            setOpenRejectInvitation(data);
            setDiaLogBoxBlur(false);
          }}
          disable={() => setDel(true)}
          RejectRegisterId={rejectVisitId}
          module={"Visitors"}
          subModule={"Approvals Blacklist Request"}
          rejectVisit={rejectVisit}
        />
      )}

      {openBlacklistVisitor && (
        <BlockVisitorForm
          open={openBlacklistVisitor}
          handleClose={(data) => {
            setOpenBlacklistVisitor(data);
            setDiaLogBoxBlur(false);
          }}
          disable={() => setDel(true)}
          BlacklistVisitorId={blacklistId}
          restrictReasonType={restrictReasonType}
          restrictReason={restrictReason}
          module={"Visitors"}
          subModule={"Approvals Blacklist Request"}
          blockListName={`${visitorFirstName}${
            visitorLastName ? " " + visitorLastName : ""
          }`}
          removeAccess={removeAccess}
        />
      )}
    </>
  );
}

export default BlockRequestsApprovals;
